import denominationallComponent from './denomination.all.component';

let denominationallModule = angular.module('denominationall', [
])

.component('denominationall', denominationallComponent)

.name;

export default denominationallModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/all/index.js